<style src="./base.css" scoped></style>
<style src="./elements.css" scoped></style>
<style src="./listingTables.css" scoped></style>
<style>@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,800;1,800&display=swap');</style>

<template>
  <div class="project-list-container">
    <h1 class="page-title">Member Management</h1>
    
    <!-- Actions Row -->
    <div class="actions">
      <div class="search-container">
        <input type="text" v-model="searchTerm" placeholder="Search members..." />
      </div>
      <button @click="openAddMemberModal" class="action-button">
        Add Member
      </button>
      <!-- You can add additional action buttons here if needed -->
    </div>
    
    <!-- Members Table -->
    <table class="project-table">
      <thead>
        <tr>
          <th>First Name</th>
          <th>Surname</th>
          <th>Email</th>
          <th>Role</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in displayedUsers" :key="user.docId">
          <td>{{ user.firstName }}</td>
          <td>{{ user.surname }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.role }}</td>
          <td>
            <button class="action-button-mini" @click="editMember(user)">Edit</button>
            <button class="delete-button-mini" @click="deleteMember(user)">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
    <button v-if="filteredUsers.length > visibleCount" @click="loadMore" class="action-button">
      Load More
    </button>
    <p v-if="error" class="error-message">{{ error }}</p>

    <!-- Add/Edit Member Modal -->
    <div v-if="showAddMemberModal" class="modal-overlay">
      <div class="modal-content">
        <h2 class="page-title-modal">{{ isEditing ? "Edit Member" : "Add member" }}</h2>
        <form @submit.prevent="submitMember">
          <div class="memberFormText">
            <label>Full Name</label>
            <input type="text" v-model="memberForm.fullName" required />
          </div>
          <div class="memberFormText">
            <label>First Name</label>
            <input type="text" v-model="memberForm.firstName" required />
          </div>
          <div class="memberFormText">
            <label>Middle Name</label>
            <input type="text" v-model="memberForm.middleName" />
          </div>
          <div class="memberFormText">
            <label>Surname</label>
            <input type="text" v-model="memberForm.surname" required />
          </div>
          <div class="memberFormText">
            <label>Email</label>
            <input type="email" v-model="memberForm.email" required />
          </div>
          <div class="memberFormText">
            <label>Position</label>
            <input type="text" v-model="memberForm.position" />
          </div>
          <div class="memberFormText">
            <label>Permission</label>
            <select v-model="memberForm.role">
              <option value="admin">admin</option>
              <option value="production">production</option>
              <option value="producer">producer</option>
              <option value="creative">director</option>
            </select>
          </div>
          <div class="memberFormText">
            <label>Department</label>
            <input type="text" v-model="memberForm.department" />
          </div>
          <div class="actions">
            <button type="submit" class="action-button">
              {{ isEditing ? "Update Member" : "Create profile" }}
            </button>
            <button type="button" class="retired-projects-btn" @click="closeModal">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import MemberManagementLogic from "./MemberManagementLogic.js";

export default {
  name: "MemberManagement",
  mixins: [MemberManagementLogic]
};
</script>

<style scoped>
  .page-title-modal {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 15px;
    margin-top: 30px;
  }
.action-button-mini {
  margin: 0px 10px 0px 0px;
}
.memberFormText {
    padding-bottom: 12px;
    font-weight: 800;
  }
  .memberFormText input,
  .memberFormText select {
    font-family: "Courier Prime", monospace;
    font-weight: 400;
    font-style: normal;
    width: 92%;
    padding: 10px;
    border: 1px solid #C9BF9B;
    box-shadow: inset 0px 4px 3px #dacb9736;
    border-radius: 9px;
    font-size: 14px;
    color: #111827;
    background-color: #F8F7F3;
    max-width: 680px;
  }
</style>